import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import { useDispatch } from 'react-redux';
import UseProductHook from 'hooks/UseProductHook';
import { toast } from 'react-toastify';

const ProductModal = ({ isOpen, onClose, product, onSave, mode = 'add' }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    price: '',
    originalPrice: '',
    inventory: '',
    category: '',
    status: 'active',
    image: '',
    sku: '',
    tags: [],
    trackInventory: true,
    allowBackorders: false,
    featured: false,
    _id:''
  });
const {createProduct,updateProducts} = UseProductHook();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const categoryOptions = [
    { value: 'product', label: 'Products' },
    { value: 'service', label: 'Services' },
    // { value: 'home_garden', label: 'Home & Garden' },
    // { value: 'sports', label: 'Sports & Outdoors' },
    // { value: 'books', label: 'Books' },
    // { value: 'toys', label: 'Toys & Games' },
    // { value: 'health', label: 'Health & Beauty' },
    // { value: 'automotive', label: 'Automotive' }
  ];

  const statusOptions = [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'draft', label: 'Draft' }
  ];

  useEffect(() => {
    if (product && mode === 'edit') {
      setFormData({
        name: product.name || '',
        // description: product.description || '',
        price: product.price?.toString() || '',
        // originalPrice: product.originalPrice?.toString() || '',
        // inventory: product.inventory?.toString() || '',
        category: product.category || '',
        status: product.status || 'active',
        _id:product?._id || '',
        // image: product.image || '',
        // sku: product.sku || '',
        // tags: product.tags || [],
        // trackInventory: product.trackInventory !== false,
        // allowBackorders: product.allowBackorders || false,
        // featured: product.featured || false
      });
    } else if (mode === 'add') {
      setFormData({
        name: '',
        // description: '',
        price: '',
        // originalPrice: '',
        // inventory: '',
        category: '',
        status: 'active',
        // image: '',
        // sku: '',
        // tags: [],
        // trackInventory: true,
        // allowBackorders: false,
        // featured: false
      });
    } else if (mode === 'duplicate' && product) {
      setFormData({
        name: `${product.name} (Copy)`,
        // description: product.description || '',
        price: product.price?.toString() || '',
        // originalPrice: product.originalPrice?.toString() || '',
        // inventory: '0',
        category: product.category || '',
        status: 'draft',
        // image: product.image || '',
        // sku: '',
        // tags: product.tags || [],
        // trackInventory: product.trackInventory !== false,
        // allowBackorders: product.allowBackorders || false,
        // featured: false
      });
    }
    setErrors({});
  }, [product, mode, isOpen]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Product name is required';
    }

    if (!formData.price || parseFloat(formData.price) <= 0) {
      newErrors.price = 'Valid price is required';
    }

    // if (formData.originalPrice && parseFloat(formData.originalPrice) <= parseFloat(formData.price)) {
    //   newErrors.originalPrice = 'Original price must be higher than current price';
    // }

    if (!formData.category) {
      newErrors.category = 'Category is required';
    }

    // if (formData.trackInventory && (!formData.inventory || parseInt(formData.inventory) < 0)) {
    //   newErrors.inventory = 'Valid inventory quantity is required';
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    
    try {
      const productData = {
        ...formData,
        price: parseFloat(formData.price),
        // originalPrice: formData.originalPrice ? parseFloat(formData.originalPrice) : null,
        // inventory: formData.trackInventory ? parseInt(formData.inventory) : null,
        // sku: formData.sku || `SKU-${Date.now()}`,
        id: mode === 'edit' ? product.id : Date.now(),
        createdAt: mode === 'edit' ? product.createdAt : new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
      if(mode =='add'){

        await createProduct(formData);
      }else if(mode == 'edit'){
        await updateProducts(formData);
      }

      await onSave(productData, mode);
      onClose();
    } catch (error) {
      toast .error("Failed to save product");
      console.error('Error saving product:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  const modalTitle = mode === 'add' ? 'Add New Product' : 
                    mode === 'edit'? 'Edit Product' : 'Duplicate Product';

  return (
    <div className="fixed inset-0 z-1200 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="fixed inset-0 bg-black/50" onClick={onClose} />
        
        <div className="relative bg-card border border-border rounded-lg w-full max-w-2xl max-h-[90vh] overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-border">
            <h2 className="text-xl font-semibold text-foreground">
              {modalTitle}
            </h2>
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
              className="micro-animation"
            >
              <Icon name="X" size={20} />
            </Button>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="overflow-y-auto max-h-[calc(90vh-140px)]">
            <div className="p-6 space-y-6">
              {/* Basic Information */}
              <div className="space-y-4">
                <h3 className="text-lg font-medium text-foreground">Basic Information</h3>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="md:col-span-2">
                    <Input
                      label="Product Name"
                      type="text"
                      placeholder="Enter product name"
                      value={formData.name}
                      onChange={(e) => handleInputChange('name', e.target.value)}
                      error={errors.name}
                      required
                    />
                  </div>
                  
                  {/* <Input
                    label="SKU"
                    type="text"
                    placeholder="Auto-generated if empty"
                    value={formData.sku}
                    onChange={(e) => handleInputChange('sku', e.target.value)}
                    description="Unique product identifier"
                  /> */}
                  
                  <Select
                    label="Category"
                    options={categoryOptions}
                    value={formData.category}
                    onChange={(value) => handleInputChange('category', value)}
                    error={errors.category}
                    required
                  />
                </div>

                {/* <div>
                  <Input
                    label="Description"
                    type="text"
                    placeholder="Enter product description"
                    value={formData.description}
                    onChange={(e) => handleInputChange('description', e.target.value)}
                    description="Brief description of the product"
                  />
                </div> */}

                {/* <div>
                  <Input
                    label="Product Image URL"
                    type="url"
                    placeholder="https://example.com/image.jpg"
                    value={formData.image}
                    onChange={(e) => handleInputChange('image', e.target.value)}
                    description="URL of the product image"
                  />
                </div> */}
              </div>

              {/* Pricing */}
              <div className="space-y-4">
                <h3 className="text-lg font-medium text-foreground">Pricing</h3>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Input
                    label="Price"
                    type="number"
                    placeholder="0.00"
                    value={formData.price}
                    onChange={(e) => handleInputChange('price', e.target.value)}
                    error={errors.price}
                    required
                    min="0"
                    step="0.01"
                  />
                  
                  {/* <Input
                    label="Original Price"
                    type="number"
                    placeholder="0.00"
                    value={formData.originalPrice}
                    onChange={(e) => handleInputChange('originalPrice', e.target.value)}
                    error={errors.originalPrice}
                    min="0"
                    step="0.01"
                    description="For showing discounts"
                  /> */}
                </div>
              </div>

              {/* Inventory */}
              {/* <div className="space-y-4">
                <h3 className="text-lg font-medium text-foreground">Inventory</h3>
                
                <div className="space-y-4">
                  <Checkbox
                    label="Track inventory for this product"
                    checked={formData.trackInventory}
                    onChange={(e) => handleInputChange('trackInventory', e.target.checked)}
                  />
                  
                  {formData.trackInventory && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <Input
                        label="Inventory Quantity"
                        type="number"
                        placeholder="0"
                        value={formData.inventory}
                        onChange={(e) => handleInputChange('inventory', e.target.value)}
                        error={errors.inventory}
                        required={formData.trackInventory}
                        min="0"
                      />
                      
                      <div className="flex items-end">
                        <Checkbox
                          label="Allow backorders"
                          checked={formData.allowBackorders}
                          onChange={(e) => handleInputChange('allowBackorders', e.target.checked)}
                          description="Sell when out of stock"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div> */}

              {/* Settings */}
              <div className="space-y-4">
                <h3 className="text-lg font-medium text-foreground">Settings</h3>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Select
                    label="Status"
                    options={statusOptions}
                    value={formData.status}
                    onChange={(value) => handleInputChange('status', value)}
                    required
                  />
                  
                  {/* <div className="flex items-end">
                    <Checkbox
                      label="Featured product"
                      checked={formData.featured}
                      onChange={(e) => handleInputChange('featured', e.target.checked)}
                      description="Show in featured section"
                    />
                  </div> */}
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-end space-x-3 p-6 border-t border-border bg-muted/30">
              <Button
                type="button"
                variant="outline"
                onClick={onClose}
                disabled={loading}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                loading={loading}
                iconName="Save"
                iconPosition="left"
                iconSize={16}
              >
                {mode === 'add' ? 'Add Product' : 
                 mode === 'edit'? 'Save Changes' : 'Create Copy'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProductModal;